import { render } from "./Muertomodal.vue?vue&type=template&id=59338cd4"
import script from "./Muertomodal.vue?vue&type=script&lang=js"
export * from "./Muertomodal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__